import React, { Fragment, useState, useEffect } from "react";
import {
    Button,
    makeStyles,
    Grid,
    Divider,
    Backdrop,
    CircularProgress
} from "@material-ui/core";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import middleware from "configurations/axios";
import apis from "./apis";

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,
    },
    radio: {
        display: "-webkit-box",
        marginTop: "0px",
    },
    radioLable: {
        color: palette.primary.main,
        display: "flex",
    },
    radioButton: {
        marginTop: "0px",
        paddingTop: "0px",
    },
    divForm: {
        marginBottom: "1%",
    },
    divInput: {
        marginBottom: "1%",
        paddingRight: "1%",
        paddingLeft: "0.5%",
    },
    divButton: {
        paddingLeft: "3%",
        paddingRight: "3%",
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}));

const AffiliationPac = ({ data, onShowAlert, handleCloseReload = () => { } }) => {
    const classes = useStyles();
    const classesGlobal = useStylesGlobal();
    const [company, setCompany] = useState(data);
    const [registerCompany, setRegisterCompany] = useState({
        rucEmpresa: company.idEmpresa,
        razonSocial: company.razonSocialempresa,
        direccionEmpresa: company.direccion,
        correoElectronico: company.correoPrincipal,
        telefono: company.telefonoPrincipal,
        apiKey: company.key,
        tipoContribuyente: company.tipoContribuyente,
        digitoVerificador: company.digitoVerificador,
        direccionSucursal: company.direccion,
        unificadoSucursal: "8-8-9",
        telefonoSucursal: company.telefonoPrincipal,
        correoSucursal: company.correoPrincipal,
        coordenadasSucursal: "9.003071,-79.501305"
    });
    const [objValores, setObjValores] = useState({})
    const [openLoader, setOpenLoader] = useState(false);

    const [stateAffiliation, setStateAffiliation] = useState("");
    const [itipSol, setItipSol] = useState(0);
    useEffect(() => { getObject(data); }, []);
    useEffect(() => {
        if (company.estadoAfiliacionPac == 1 || company.estadoAfiliacionPac == 2) {
            setStateAffiliation("Afiliada")
        }
        if (company.estadoAfiliacionPac == 3) {
            setStateAffiliation("Pendiente")
        }
        if (company.estadoAfiliacionPac == 4) {
            setStateAffiliation("A espera de comunicación con la DGI")
        }
    }, [company]);

    useEffect(() => {
        if (itipSol != 0) {
            handleGenerate()
        }
    }, [itipSol]);

    const getObject = (obj) => {
        setObjValores(obj)
    }

    const handleGenerate = async () => {
        setOpenLoader(true);
        await middleware.post(apis.affiliation_company_pac, registerCompany).then(
            response => {
                if (response.status >= 200 && response.status <= 300) {
                    if (response.data === 1) {
                        onShowAlert({ show: true, msg: 'La afiliación de la empresa al PAC fue un éxito.', type: "success" });
                        setCompany({ ...company, estadoAfiliacionPac: itipSol })
                    }
                    if (response.data === 3) {
                        onShowAlert({
                            show: true, msg: 'El RUC de la empresa no posee resolución de autorización de uso de factura electrónica.', type: "error"
                        });
                        setCompany({ ...company })
                    }
                    if (response.data === 4) {
                        onShowAlert({ show: true, msg: 'Existen problemas al comunicarse con la DGI. Por favor intente más tarde o contáctese con soporte', type: "error" });
                        setCompany({ ...company })
                    }
                }
                handleCloseReload()
                setOpenLoader(false);
            }
        ).catch(
            exception => {
                if (exception.response) {
                    if (exception.response.status === 400) {
                        if (exception.response.data.apierror.mensajeSistema != null) {
                            onShowAlert({
                                show: true,
                                msg: exception.response.data.apierror.mensajeSistema,
                                type: "error",
                            });
                        } else {
                            onShowAlert({ show: true, msg: 'Existen problemas en la red. Contáctese con el administrador del Sistema.', type: "error" });
                        }
                    } else {
                        onShowAlert({ show: true, msg: 'Existen problemas en la red. Contáctese con el administrador del Sistema.', type: "error" });
                    }
                    setOpenLoader(false);

                }
            }
        );
    }

    return (
        <Fragment>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
            >
                <Grid item md={12} xs={12}>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Grid item md={4} xs={12}>
                        <label>
                            ESTADO AFILIACIÓN AL PAC:{" "}
                            <font color={palette.error.main}>*</font>
                        </label>
                    </Grid>

                    <Grid item md={4} xs={12} className={classes.divInput}>
                        <input class="form-control" disabled
                            value={stateAffiliation}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Grid item md={12} xs={12}>
                        <Divider></Divider>
                    </Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={(company.estadoAfiliacionPac == 1 || company.estadoAfiliacionPac == 2) ? true : false}
                        onClick={() => setItipSol(1)}
                        className={classesGlobal.marginButton}
                    >
                        Afiliar empresa al PAC
                    </Button>
                </Grid>
            </Grid>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    );
};

export default AffiliationPac;
